import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IInstantMessageChannelInvitation {
    id: string;
    sender: IModifyUser;
    getHash(): string;
}

export class InstantMessageChannelInvitation implements IInstantMessageChannelInvitation {
    id: string;
    sender: ModifyUser;

    constructor();
    constructor(obj: IInstantMessageChannelInvitation);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.sender = new ModifyUser(obj ? obj.sender : null);
    }

    getHash(): string {
        return this.id + "#" + this.sender.code;
    }
}